import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="relative py-16 md:py-24 px-4 md:px-6 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Warm%20abstract%20digital%20landscape%20with%20golden%20amber%20gradients%2C%20flowing%20organic%20shapes%2C%20soft%20atmospheric%20glow%2C%20minimal%20abstract%20art%2C%20elegant%20and%20modern%20composition%2C%20warm%20terracotta%20and%20gold%20tones&width=1800&height=600&seq=cta-bg-gaming&orientation=landscape"
          alt=""
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-secondary-950/90 via-secondary-950/80 to-secondary-950/90"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-background-50 mb-4">
          准备好开启你的游戏之旅了吗？
        </h2>
        <p className="text-base text-secondary-300 mb-8 max-w-xl mx-auto leading-relaxed">
          加入黄油游戏库，探索海量精选独立游戏，发现属于你的游戏天地。
          注册即可获得专属游戏推荐和社区互动体验。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/action-adventure"
            className="px-8 py-3.5 bg-primary-500 text-background-50 rounded-full text-base font-semibold hover:bg-primary-600 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            立即探索
          </Link>
          <Link
            to="/about"
            className="px-8 py-3.5 bg-background-50/10 text-background-50 backdrop-blur-sm rounded-full text-base font-semibold hover:bg-background-50/20 transition-all duration-300 border border-background-50/15 whitespace-nowrap cursor-pointer"
          >
            了解详情
          </Link>
        </div>
      </div>
    </section>
  );
}